import { c } from '../../../utils/tailwind-merge';
import { CounterProps } from './Counter.types';

export const Counter = ({
  counter,
  ariaLabel,
  className = '',
}: CounterProps) => {
  return (
    <div
      className={c(
        'flex items-center justify-center rounded-[48px] bg-blue px-1.5 py-px text-[10px] font-semibold leading-4 text-white',
        className
      )}
      aria-label={ariaLabel}
    >
      {counter}
    </div>
  );
};
